import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="bg-navy px-3 py-4 sm:px-6" data-id="element-18" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-19" data-mp="pjg7a5ljxg31">
        <h2 className="text-center font-heading text-[1.15rem] font-extrabold uppercase text-gold sm:text-[1.85rem]" data-id="element-20" data-mp="avcxsm8avm9h">
          🎁 5 Professional Bonuses Included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-21" data-mp="fs3bj2wmu5rq">
          {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-l-[5px] border-gold bg-white p-2.5 shadow-sm" data-id="element-22" data-mp="1stzmffglxtk">
              <h3 className="font-heading text-[0.72rem] font-extrabold uppercase leading-tight tracking-wide text-navy sm:text-[0.9rem]" data-id="element-23" data-mp="3o24v01rj7xub">
                🎁 Bonus {bonus.number} — {bonus.title}
              </h3>
              <p className="mt-0.5 font-heading text-[0.68rem] font-semibold text-brightblue sm:text-[0.8rem]" data-id="element-24" data-mp="1mb9y16ll9sm0">
                {bonus.subtitle}
              </p>
              {bonus.lines.map(line => <p key={line} className="mt-0.5 text-[0.8rem] leading-[1.35] text-muted first-of-type:mt-1 sm:text-[0.95rem]" data-id="element-25" data-mp="3id55p9kqj9cd">
                  {line}
                </p>)}
              <p className="mt-1 font-heading text-[0.68rem] font-bold uppercase tracking-wide text-gold sm:text-[0.8rem]" data-id="element-26" data-mp="3r8kv9eegj2c5">
                {bonus.steps}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}